import React from 'react';
import { ErrorPage } from '@redacted/react-components';

function ServerError(props) {
  return (<ErrorPage {...props} />);
}

export default ServerError;
